module.exports = __webpack_public_path__ + "9ef0b8835dad762ed768a2826d1e63e1.svg";